import React from 'react'
import ContactForm from '../mainPage/home/subcomponents/contactForm';

const Contact = () => (
    <section className='pt-0 bg-primary'>
        <ContactForm isPage={true} />
    </section>
)

export default Contact;